import { Box, Modal, Typography, useTheme } from "@mui/material";
import { CustomeModalButton } from "../../../lib/formik/NewFormInputs";
import { useSelector } from "react-redux";
import { USER_ROLES } from "../../../utils/constant";
import { useHistory } from "react-router-dom";
import { isRMLikeRole } from "../../../utils/utilityFunctions";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    maxWidth: '533px',
    bgcolor: 'background.paper',
    // border: '2px solid #000',
    boxShadow: 24,
    borderRadius: '12px',
    p: '24px',
    ':focus': {
        outline: 'none'
    },
    ':focus-visible': {
        outline: '2px solid',
        outlineColor: 'primary.500',
        outlineOffset: '2px',
    }
}

export default function RiskProfilePopup(props: any): JSX.Element {
    const { open, setClose, isLoading, text } = props;
    const { palette } = useTheme();
    const { role = '' } = useSelector((state: any) => state.auth);
    const history = useHistory();
    const { pathname } = history.location;
    const isInvestMore = pathname.includes('invest-more');
    return (
        <Modal
            open={open}
            // onClose={handleClose}
            aria-label="Risk profile"
            aria-describedby="risk-profile-modal-description"
        >
            <Box
                sx={style}
            >
                <Typography id="risk-profile-modal-description">{text}</Typography>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', mt: '48px' }}>
                    <CustomeModalButton
                        lookType={isRMLikeRole(role) ? 'contained' : 'outlined'}
                        btnText={isRMLikeRole(role) ? isInvestMore ? "Go Back" : 'Go Back to Explore Funds' : 'Go Back'} onClick={() => setClose('cancel')}
                        disabled={isLoading}
                        boxStyle={{ borderRadius: '4px' }}
                    />
                    {role === USER_ROLES.INVESTOR && (
                        <CustomeModalButton
                            lookType={'contained'}
                            btnText={'Proceed'}
                            disabled={isLoading}
                            onClick={() => setClose('continue')}
                            boxStyle={{ borderRadius: '4px' }} />
                    )}
                </Box>
            </Box>
        </Modal >
    )
}